import tarotCardChange from './actions/tarotCardChange';
import tarotCardCreate from './actions/tarotCardCreate';
import tarotCardDetail from './actions/tarotCardDetail';
import tarotCardsList from './actions/tarotCardsList';
import getTarotCards from './getters/getTarotCards';
import tarotCardsUpload from './mutations/tarotCardsUpload';

const actions = {
    tarotCardChange,
    tarotCardCreate,
    tarotCardDetail,
    tarotCardsList
};

const mutations = {
    tarotCardsUpload
};

const getters = {
    getTarotCards
};

export default { actions, mutations, getters };
